export default __webpack_public_path__ + "static/media/road-works-outline.37b8e089.svg";